module.exports = __webpack_public_path__ + "static/media/computador_us_old.c3b4e204.png";